export default __webpack_public_path__ + "static/successImage2-940816b867fa76e2978a252965f7f95c.png";